<template>
  <v-card
    flat
    class="ma-2 clickable brand-group-card-hover-shadow"
    :class="{
      'grey--text text--darken-3': !selected,
      'msr--text msr--bold-outline elevation-12': selected,
    }"
    :title="group.name"
    :width="cardWidth"
    :height="cardHeight"
    @click.native="$emit('toggled')"
  >
    <v-layout
      column
      fill-height
    >
      <v-layout class="pt-1 px-1">
        <v-img
          v-if="group.logo_image_url"
          class="background-size-contain"
          :src="group.logo_image_url"
          :aspect-ratio="imageMaxWidth / imageMaxHeight"
        />
      </v-layout>
      <v-card-title
        class="px-2 pb-2"
        style="justify-content: center"
        :class="{
          'subheading pt-2': $vuetify.breakpoint.smAndUp,
          'pt-1': $vuetify.breakpoint.xsOnly,
        }"
        :style="{'max-width': cardWidth + 'px'}"
      >
        <span :class="{bold: selected}">{{ group.name }}</span>
      </v-card-title>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const isMobile = this.$vuetify.breakpoint.xsOnly;
    return {
      cardWidth: isMobile ? 100 : 135,
      cardHeight: isMobile ? 100 : 135,
    };
  },
  computed: {
    imageMaxWidth() {
      return this.cardWidth;
    },
    imageMaxHeight() {
      const offset = 64;
      return this.cardHeight - offset;
    },
  },
};
</script>

<style scoped>
.brand-group-card-hover-shadow {
  /* https://codepen.io/michellebarker/pen/vYWgvZK */
  box-shadow: 0.1rem 0.1rem 0.5rem rgb(0 0 0 / 0.05),
    0.15rem 0.15rem 0.75rem rgb(0 0 0 / 0.1);
}
.brand-group-card-hover-shadow:hover {
  /* aka .elevation-12 */
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),
    0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}

.bold {
  font-weight: bold;
}

.background-size-contain >>> .v-image__image {
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandGroupCard.vue